import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

// Store
import { jupiterStore } from '@Store/jupiter';

// Hook
import { valPackage } from '@Hooks/useValidatePlanet';

// STYLES
import style from '@Components/Planets/planets.module.scss';
import buttons from '@Sass/components/buttons.module.scss';
import lines from '@Components/Planets/lines.module.scss';

// IMAGES
import _tank from '@Assets/images/tanque.png';
import _lock from '@Assets/images/lock.png';
import jupiter from '@Assets/images/planets/jupiter.svg';

export const Jupiter = ({ jupiterInfo }) => {
  const [skills, setSkills] = useState([
    {
      skill: '',
    },
    {
      skill: '',
    },
  ]);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('JUPITER');

  // Store de mercurio
  const { getJupiter, dataJupiter } = jupiterStore(
    (state) => ({
      getJupiter: state.getJupiter,
      dataJupiter: state.dataJupiter,
    }),
    shallow
  );

  const { validateProject } = valPackage();

  useEffect(() => {
    if (jupiterInfo.titulo) {
      setSkills(jupiterInfo.skills);
      setDescription(jupiterInfo.descripcion);
      setTitle(jupiterInfo.titulo);
    }
  }, [jupiterInfo]);

  return (
    <div>
      <div className={style.cardItem}>
        <div className={style.card_name_tankItem}>
          <h2>{title}</h2>
          <div className={style.card_tank_value}>
            <label>x3</label>
            <img src={_tank} alt="tank" />
          </div>
        </div>
        <div className={`${style.planetImage_content} ${lines.lines_jupiter}`}>
          <div className={lines.lines_jupiter_1}>
            <p>{skills[0].skill}</p>
          </div>
          <div className={lines.lines_jupiter_2}>
            <p>{skills[1].skill}</p>
          </div>
          {getJupiter().lockedPlanet === 'desbloqueado' ? (
            <></>
          ) : (
            <img src={_lock} alt="lock" className={style.imgLock} />
          )}
          <img src={jupiter} alt="planet" className={`${style.planetImage} ${style.jupiter}`} />
        </div>
        <div className={style.planetInfo}>
          <p>{description}</p>
        </div>
        <div className={style.planetButton_content}>
          {getJupiter().id ? (
            <button
              className={`${
                dataJupiter.complete === 1
                  ? buttons.buttonPlanetCompleted
                  : dataJupiter.complete === 2
                  ? buttons.buttonPlanetIncomplete
                  : dataJupiter.complete === 0
                  ? buttons.buttonPlanet
                  : buttons.buttonPlanet
              }`}
              onClick={() => validateProject('jupiter', 3)}
            >
              {dataJupiter.label}
            </button>
          ) : (
            <button className={style.moon_launchBtn} onClick={() => validateProject('jupiter', 3)}>
              ACCEDER
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
